import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  link: {
    fontSize: '0.875rem', // body2 font size
    fontWeight: 400, // body2 font weight
    color: 'text.secondary', // Same as address
    textDecoration: 'none',
    '&:hover': {
      color: 'primary.main',
      textDecoration: 'underline',
    },
  },
};

export default styles;
